import _classCallCheck from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/tmp/aauthui/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import * as asn1js from "asn1js";
import { getParametersValue, clearProps } from "pvutils";
import GeneralName from "./GeneralName.js"; //**************************************************************************************

/**
 * Class from RFC5280
 */

var GeneralNames = /*#__PURE__*/function () {
  //**********************************************************************************

  /**
   * Constructor for GeneralNames class
   * @param {Object} [parameters={}]
   * @param {Object} [parameters.schema] asn1js parsed value to initialize the class from
   */
  function GeneralNames() {
    var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    _classCallCheck(this, GeneralNames);

    //region Internal properties of the object

    /**
     * @type {Array.<GeneralName>}
     * @desc Array of "general names"
     */
    this.names = getParametersValue(parameters, "names", GeneralNames.defaultValues("names")); //endregion
    //region If input argument array contains "schema" for this object

    if ("schema" in parameters) this.fromSchema(parameters.schema); //endregion
  } //**********************************************************************************

  /**
   * Return default values for all class members
   * @param {string} memberName String name for a class member
   */


  _createClass(GeneralNames, [{
    key: "fromSchema",
    //**********************************************************************************

    /**
     * Convert parsed asn1js object into current class
     * @param {!Object} schema
     */
    value: function fromSchema(schema) {
      //region Clear input data first
      clearProps(schema, ["names", "generalNames"]); //endregion
      //region Check the schema is valid

      var asn1 = asn1js.compareSchema(schema, schema, GeneralNames.schema({
        names: {
          blockName: "names",
          generalNames: "generalNames"
        }
      }));
      if (asn1.verified === false) throw new Error("Object's schema was not verified against input data for GeneralNames"); //endregion
      //region Get internal properties from parsed schema

      this.names = Array.from(asn1.result.generalNames, function (element) {
        return new GeneralName({
          schema: element
        });
      }); //endregion
    } //**********************************************************************************

    /**
     * Convert current object to asn1js object and set correct values
     * @returns {Object} asn1js object
     */

  }, {
    key: "toSchema",
    value: function toSchema() {
      //region Construct and return new ASN.1 schema for this object
      return new asn1js.Sequence({
        value: Array.from(this.names, function (element) {
          return element.toSchema();
        })
      }); //endregion
    } //**********************************************************************************

    /**
     * Convertion for the class to JSON object
     * @returns {Object}
     */

  }, {
    key: "toJSON",
    value: function toJSON() {
      return {
        names: Array.from(this.names, function (element) {
          return element.toJSON();
        })
      };
    } //**********************************************************************************

  }], [{
    key: "defaultValues",
    value: function defaultValues(memberName) {
      switch (memberName) {
        case "names":
          return [];

        default:
          throw new Error("Invalid member name for GeneralNames class: ".concat(memberName));
      }
    } //**********************************************************************************

    /**
     * Return value of pre-defined ASN.1 schema for current class
     *
     * ASN.1 schema:
     * ```asn1
     * GeneralNames ::= SEQUENCE SIZE (1..MAX) OF GeneralName
     * ```
     *
     * @param {Object} parameters Input parameters for the schema
     * @param {boolean} [optional=false] Flag would be element optional or not
     * @returns {Object} asn1js schema object
     */

  }, {
    key: "schema",
    value: function schema() {
      var parameters = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      var optional = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      /**
       * @type {Object}
       * @property {string} utcTimeName Name for "utcTimeName" choice
       * @property {string} generalTimeName Name for "generalTimeName" choice
       */
      var names = getParametersValue(parameters, "names", {});
      return new asn1js.Sequence({
        optional: optional,
        name: names.blockName || "",
        value: [new asn1js.Repeated({
          name: names.generalNames || "",
          value: GeneralName.schema()
        })]
      });
    }
  }]);

  return GeneralNames;
}(); //**************************************************************************************


export { GeneralNames as default };